import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { OptionIcon, OptionIconChecked } from '../../../../../global/oe-radio-options/option-icon';
import { IRolodexContactDTO } from '../../../../../../api/rolodex.dao';
import { EMAIL_TEXT, FIRST_NAME_TEXT, LAST_NAME_TEXT } from '../../attendees.texts';
import { ORG_NAME_TEXT, PREFERRED_NAME_TEXT } from './attendee-mapping-form.texts';
import DefaultButton from '../../../../../global/default-button/default-button';
import { EDIT_TEXT } from '../../../../../../constants/common-labels.constants';

export interface IContactInfoProps {
    contact: IRolodexContactDTO;
    openEditRolodexContactPopup: (contactId: number) => void;
    editRolodexContactPermission: boolean;
}

export interface IContactRowProps {
    contact: IRolodexContactDTO;
    isSelected: boolean;
    onSelect: () => void;
    openEditRolodexContactPopup: (contactId: number) => void;
    editRolodexContactPermission: boolean;
}

const ContactInfo = ({
    contact,
    openEditRolodexContactPopup,
    editRolodexContactPermission,
}: IContactInfoProps) => (
    <div className='attendee-mapping-form__contact'>
        <span className='overflow-ellipsis' title={contact.firstName}>{contact.firstName}</span>
        <span className='overflow-ellipsis' title={contact.lastName}>{contact.lastName}</span>
        <span className='overflow-ellipsis' title={contact.preferredName}>{contact.preferredName}</span>
        <span className='overflow-ellipsis' title={contact.organizationName}>{contact.organizationName}</span>
        <span className='overflow-ellipsis' title={contact.primaryEmail}>{contact.primaryEmail}</span>
        {editRolodexContactPermission &&
            <DefaultButton
                className='visible-while-hovered'
                text={<FormattedMessage {...EDIT_TEXT} />}
                onClick={e => {
                    e.stopPropagation();
                    openEditRolodexContactPopup(contact.contactId);
                }}
                modifier='slim'
            />
        }
    </div>
);

export const ContactsListHeader = ({ withIconOffset }: { withIconOffset?: boolean }) => (
    <div
        className={classnames('attendee-mapping-form__results-header', {
            'attendee-mapping-form__results-header--icon-offset': withIconOffset,
        })}
    >
        <div className='attendee-mapping-form__contact'>
            <span><FormattedMessage {...FIRST_NAME_TEXT} /></span>
            <span><FormattedMessage {...LAST_NAME_TEXT} /></span>
            <span><FormattedMessage {...PREFERRED_NAME_TEXT} /></span>
            <span><FormattedMessage {...ORG_NAME_TEXT} /></span>
            <span><FormattedMessage {...EMAIL_TEXT} /></span>
        </div>
    </div>
);


export const ContactRow = ({
    contact,
    isSelected,
    onSelect,
    openEditRolodexContactPopup,
    editRolodexContactPermission,
}: IContactRowProps) => (
    <div
        className={classnames('attendee-mapping-form__result-row', {
            'attendee-mapping-form__result-row--selected': isSelected,
        })}
        onClick={onSelect}
    >
        {isSelected ? <OptionIconChecked /> : <OptionIcon />}
        <ContactInfo
            contact={contact}
            openEditRolodexContactPopup={openEditRolodexContactPopup}
            editRolodexContactPermission={editRolodexContactPermission}
        />
    </div>
);
